// Numbers
export const MAX_PRICE = 250000;
export const MAX_SIZE = 500;
// Urls
export const IMAGE_SERVER_URL = 'https://photos.rentimizer.is';



// WEBPACK FOOTER //
// ./src/browser/app/constants/index.js